import React, { Fragment, useState } from 'react';
import { Button, Table, Form, Row, Col, Alert } from 'react-bootstrap';
import SolicitacaoService from '../../../services/solicitacao';
import '../../../styles/diario.scss'
import { Link } from 'react-router-dom';


function SolicitarScreen() {
    const [id, setId] = useState('');
    const [numMem, setNumMem] = useState('');
    const [sec, setSec] = useState('');
    const [solicitacao, setSolicitacao] = useState(null);
    const [vazio, setVazio] = useState(null);

    const consultar = async () => {
        setVazio(null);
        try {
            const res = await SolicitacaoService.verSolicitacao(id);
            setSolicitacao(res.data);
        } catch (err) {
            setSolicitacao(null);
            setVazio("Não foi encontrada nenhuma solicitação com essa numeração cadastrada no sistema, por favor, verifique se a numeração está correta!")
        }
    };

    const buscar = async () => {
        setVazio(null);
        const res = await SolicitacaoService.buscarSolicitacao(`sec=${encodeURI(sec)}&numMem=${numMem}`);
        if (res.data.length >= 1) {
            const resp = await SolicitacaoService.verSolicitacao(res.data[0]._id);
            setSolicitacao(resp.data);
        } else {
            setSolicitacao(null);
            setVazio("Não encontramos nenhuma solicitação com esse número de memorando e secretaria, por favor verifique o formado do memorando (se cadastrou 12/26 ou 12/2026, por exemplo). Ou se a secretaria escolhida está correta! Para uma busca mais assertiva, use o número da solicitação enviada para o e-mail no ato do cadastro!")
        }
    };

    return (
        <Fragment>
            <h4>Busque pelo número da solicitação</h4>
            <Row xs={2} lg={3}>
                <Col xs={12} lg={8}>
                    <Form.Control
                        placeholder="Número da solicitação"
                        value={id}
                        onChange={e => setId(e.target.value)}
                    />
                </Col>
                <Col xs={6} lg={2}>
                    <Button onClick={consultar}>Consultar</Button>
                </Col>
                <Col xs={6} lg={2}>
                    <Link to={'/'}>
                        <Button variant="danger" type="button">
                            Voltar
                        </Button>
                    </Link>
                </Col>
            </Row>
            <br />
            <br />
            <h4>Ou pelo Número do Memorando e Secretaria</h4>
            <Row xs={1} lg={3}>
                <Col xs={12} lg={4}>
                    <Form.Control
                        required
                        placeholder="Número memorando"
                        value={numMem}
                        onChange={e => setNumMem(e.target.value)}
                    />
                </Col>
                <Col xs={12} lg={6}>
                    <Form.Select
                        required
                        onChange={e => setSec(e.target.value)}
                    >
                        <option>SELECIONE</option>
                        <option value="Secretaria Municipal de Segurança Pública, Administração e Mobilidade Urbana">Segurança Pública, Administração e Mobilidade Urbana</option>
                        <option value="Secretaria Municipal de Agricultura, Pecuária, Abastecimento e Aquicultura">Agricultura, Pecuária, Abastecimento e Aquicultura</option>
                        <option value="Secretaria Municipal de Educação">Educação</option>
                        <option value="Secretaria Municipal de Esporte, Lazer, Turismo e Cultura">Esporte, Lazer, Turismo e Cultura</option>
                        <option value="Secretaria Municipal de Fazenda, Planejamento, Orçamento, Indústria e Comércio">Fazenda, Planejamento, Orçamento, Indústria e Comércio</option>
                        <option value="Secretaria Municipal de Gabinete e Comunicação">Gabinete e Comunicação</option>
                        <option value="Secretaria Municipal de Controle Interno">Controle Interno</option>
                        <option value="Secretaria Municipal de Governo e Gestão">Governo e Gestão</option>
                        <option value="Secretaria Municipal de Meio Ambiente, Urbanismo e Defesa Civil">Meio Ambiente, Urbanismo e Defesa Civil</option>
                        <option value="Secretaria Municipal de Obras e Serviços Públicos">Obras e Serviços Públicos</option>
                        <option value="Secretaria Municipal de Saúde e Prevenção à Dependência Química">Saúde e Prevenção à Dependência Química</option>
                        <option value="Secretaria Municipal de Desenvolvimento Social e Direitos Humanos">Desenvolvimento Social e Direitos Humanos</option>
                        <option value="Secretaria Municipal de Trabalho, Envelhecimento Saudável e da Juventude">Trabalho, Envelhecimento Saudável e da Juventude</option>
                        <option value="Departamento de Patrimônio">Patrimônio</option>
                        <option value="Departamento de Turismo">Turismo</option>
                        <option value="Departamento de Cultura">Cultura</option>
                        <option value="Junta Militar de Macuco">Junta Militar de Macuco</option>
                    </Form.Select>

                </Col>
                <Col xs={6} lg={2}>
                    <Button onClick={buscar}>Consultar</Button>
                </Col>
            </Row>
            {solicitacao && !vazio && (
                <Table className="mt-3">
                    <tbody>
                        <tr>
                            <td>ID</td><td>{solicitacao._id}</td>
                            <td>Data: {new Date(solicitacao.dataCriacao).toLocaleDateString('pt-BR')}</td>
                            <td>Responsável: {solicitacao.responsavel}</td>
                            <td>Situação: {solicitacao.situacao}</td>
                            {solicitacao.memorando && (
                                <td>
                                    <Button variant='primary' href={solicitacao.memorando[solicitacao.memorando.length - 1].memorando} target="_blank">
                                        Ver Especificação Técnica
                                    </Button>
                                </td>
                            )}
                        </tr>
                    </tbody>
                </Table>
            )}
            {vazio && (
                <Alert variant="warning">{vazio}</Alert>
            )}
        </Fragment>
    )


}

export default SolicitarScreen;